export default __webpack_public_path__ + "static/media/bg-halopagi-2-b.1295597e.png";